<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">学生技能证书</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="formInline.student_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="学生学号">
          <el-input v-model="formInline.student_number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证书名称">
          <el-input v-model="formInline.zsmc" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="formInline.zsbh" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="发证机构">
          <el-input v-model="formInline.jdjg" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <<custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column fixed prop="student_name" label="学生姓名" width="100">
          </custom-table-column>
          <custom-table-column prop="student_number" label="学号" width="120">
          </custom-table-column>
          <custom-table-column prop="structure_1" label="院系" min-width="160">
          </custom-table-column>
          <custom-table-column prop="structure_2" label="专业" min-width="160">
          </custom-table-column>
          <custom-table-column prop="class_name" label="班级" min-width="160">
          </custom-table-column>
          <custom-table-column prop="zsmc" label="证书名称" min-width="160">
          </custom-table-column>
          <custom-table-column prop="zsbh" label="证书编号" width="160">
          </custom-table-column>
          <custom-table-column prop="xzdycs" label="已下载次数" width="160">
          </custom-table-column>
          <custom-table-column prop="jdjg" label="发证机构" width="160">
          </custom-table-column>
          <custom-table-column prop="jddjm" label="证书等级码" width="160">
          </custom-table-column>
          <custom-table-column prop="fzrq" label="发证日期" width="160">
          </custom-table-column>
          <custom-table-column prop="sfzcdzzs" label="是否支持电子证书" width="160" label-class-name="iss"
            :formatter="format_arr">
          </custom-table-column>
          <custom-table-column label="证书附件" min-width="160">
            <template slot-scope="scope" v-if="scope.row.certificate_file_url">
              <el-link type="primary" v-for="(item, index) in scope.row.certificate_file_url.split(',')" :href="item"
                :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
            </template>
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-popconfirm title="确定下载证书吗？" @confirm="downloadFile(scope.row)">
                <el-button v-if="scope.row.certificate_file_url" slot="reference" type="text"
                  size="small">下载</el-button>
              </el-popconfirm>
            </template>
          </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        class_name: '',
        student_name: '',
        student_number: '',
        zsmc: '',
        zsbh: '',
        jdjg: '',
      },
      ruleForm: {
        id: '',
        status: '',
        review_desc: ''
      },
      levell: [1, 2, 3],
      rowObj: {},
      detailDialogVisible: false
    };
  },
  components: {},
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3 ? [{ required: true, message: '请输入', trigger: 'blur' }] : [];
    },
  },
  created() {
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    async downloadFile(params) {
      let res = await this.$api.instance.interfaceServer(`api/student_skill_certificate/increment_xzdycs/${params.id}`, 'POST', params);
      if (res.code == 0 && res.data) {
        params.certificate_file_url.split(',').forEach(url => {
          this.$until.downloadFromUrl(url)
        });
      }

    },

    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/student_skill_certificate/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: "structure_2" });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
